import { useLocation } from 'react-router-dom';

const useTabLocation = () => {
  const location = useLocation();

  const params = new URLSearchParams(location.search);

  const currentTab = Number(params.get('tab')) ?? 0;

  return { currentTab, pathname: location.pathname, params };
};

export default useTabLocation;
